const translations = {
    applicationSite: 'Application Site{{number}}',
    chemical: 'Chemical to Be Applied',
    header: 'Work Order ({{number}})',
    noChemicals: 'No Chemicals Applied',
    noSites: 'No Application Sites Provided'
};

export default translations;
